import { Component, OnInit, OnDestroy } from '@angular/core';

import { LoaderMinimalGeneralService } from './service/loader-minimal-general.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-loader-minimal-general',
  standalone: true,
  imports: [],
  templateUrl: './loader-minimal-general.component.html',
  styleUrl: './loader-minimal-general.component.css'
})
export class LoaderMinimalGeneralComponent implements OnInit, OnDestroy {
  isLoading: boolean = false;
  private subscription: Subscription = new Subscription();

  constructor(private loaderService: LoaderMinimalGeneralService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.loaderService.loading$.subscribe(loading => {
        this.isLoading = loading;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
